module.exports = __webpack_public_path__ + "2146886d9a30a09e1bce27e4409d437e.ttf";